import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import FooterButtonsRow from '../shared/FooterButtonsRow/FooterButtonsRow';
import NJRTermsDocument from '../../assets/Documents/NJR/njr-serviceplan-terms.pdf';
import styles from './PlanSelection.module.css';

const ServiceFeeModal = ({ onCloseModal, tsf = [] }) => {
    const onClose = () => {
        onCloseModal();
    };
    const lowerTsf = tsf.filter((x) => x.name == 'lower')[0]?.term || 0;
    const higherTsf = tsf.filter((x) => x.name == 'higher')[0]?.term || 0;

    return (
        <Modal
            isOpen={true}
            aria-modal='true'
            className='md'
            role='dialog'
        >
            <ModalHeader>What is a service fee?</ModalHeader>
            <ModalBody>
                <p className='text-left'>
                    A service fee* is a flat rate paid when filling a claim. You can choose between a ${lowerTsf} or $
                    {higherTsf} service fee. The plan cost will vary accordingly.
                </p>
                <p className={`text-left ${styles.serviceFeeText}`}>
                    *A separate claim must be filed for each appliance and is separate from any trip or diagnosis fees,
                    which may be charged against your benefit limit. See the complete{' '}
                    <a
                        className={styles.link}
                        onClick={() => window.open(NJRTermsDocument)}
                    >
                        terms and conditions
                    </a>
                    .
                </p>
            </ModalBody>
            <ModalFooter>
                <FooterButtonsRow
                    isModal
                    buttons={{
                        primary: {
                            text: 'Close',
                            type: 'primary',
                            onClick: onClose,
                            ariaLabel: 'Close'
                        }
                    }}
                />
            </ModalFooter>
        </Modal>
    );
};

export default ServiceFeeModal;
